import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MotiveRefuzAddPayload } from './motive-refuz.interface';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MotiveRefuzService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private storeURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz.store;

    private deleteUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz.delete;

    private listUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz
            .list;

    private updateUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz.update;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.motiveRefuz
            .public;

    constructor(private http: HttpClient) { }

    storeMotivRefuz(data: MotiveRefuzAddPayload) {
        return this.http.post(this.storeURL, data, this.httpOptions);
    }

    getMotiveRefuz() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    getActiveMotiveRefuz() {
        const params = new HttpParams().set('active', '1');
        return this.http.get(this.listUrl, { ...this.httpOptions, params });
    }

    getPublicMotiveRefuz() {
        const params = new HttpParams().set('public', '1');
        return this.http.get(this.listUrl, { ...this.httpOptions, params });
    }

    updateMotivRefuz(id: number, data: MotiveRefuzAddPayload) {
        return this.http.put(this.updateUrl + id, data, this.httpOptions);
    }

    deleteMotivRefuz(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    changeStatusActive(id: number) {
        return this.http.patch(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.patch(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
